export default "__VITE_ASSET__f6fdf741__"